import { FormFieldGroup, FormLabel, FormLabelDescription, FormTextarea } from '$components'
import { z } from 'zod'
import { Input } from './types'

export const notesSchema = z.object({
  [Input.GroomingPreferences]: z.string()
    .max(2048, { message: 'Internal notes must be less than 2048 characters.' })
    .optional(),
  [Input.InternalNotes]: z.string()
    .max(2048, { message: 'Internal notes must be less than 2048 characters.' })
    .optional(),
  // [Input.Tags]: z.array(z.object({
  //   name: z.string(),
  //   color: z.string(),
  // })).default([]),
})

export function NotesStep() {
  return (
    <div className="flex flex-col gap-6 flex-grow">
      <FormFieldGroup>
        <FormLabel htmlFor={Input.GroomingPreferences}>
          Grooming Preferences
        </FormLabel>

        <FormLabelDescription>
          Add any notes about grooming preferences.
        </FormLabelDescription>

        <FormTextarea
          name={Input.GroomingPreferences}
          placeholder="Grooming preferences & notes"
        />
      </FormFieldGroup>

      <FormFieldGroup>
        <FormLabel htmlFor={Input.InternalNotes}>
          Internal Notes
        </FormLabel>

        <FormLabelDescription>
          Add any internal notes about this pet (only visible to you and your team).
        </FormLabelDescription>

        <FormTextarea
          name={Input.InternalNotes}
          placeholder="Internal notes"
        />
      </FormFieldGroup>

      {/* make tags scoped (and unique) to tenant
      <TagInput /> */}
    </div>
  )
}
